import component from './CalendarViewConstructor.vue'
export default component
